import { BRAND_INFO } from '@hub/shared'
import { relative, today } from '../lib/dates.js'
import type { Item } from '../lib/items.js'
import { brandFill, brandText, typeLabel } from './Brand.js'
import { Icon } from './Icon.js'

/**
 * One content piece on the board — deliberately sparse (Lucas, 19.10.2026:
 * „Karten übersichtlicher“): the title, then brand and release day. Type,
 * channels and everything else live in the detail sheet. The brand colour
 * runs down the left edge; the type is in the tooltip.
 */
export function ItemCard({ item, onOpen, draggable = false }: { item: Item; onOpen: () => void; draggable?: boolean }): JSX.Element {
  const late = item.start < today() && item.status !== 'veroeffentlicht' && item.status !== 'verworfen'

  return (
    <button
      type="button"
      onClick={onOpen}
      draggable={draggable}
      onDragStart={(e) => {
        e.dataTransfer.setData('text/item-id', item.id)
        e.dataTransfer.effectAllowed = 'move'
      }}
      title={`${typeLabel(item.type)} · ${BRAND_INFO[item.brand].name}`}
      className="relative block w-full min-w-0 overflow-hidden rounded-[16px] bg-cell py-3 pl-4 pr-3.5 text-left transition-[transform,box-shadow] duration-200 hover:shadow-raised active:scale-[0.985]"
    >
      <span aria-hidden="true" className="absolute inset-y-2.5 left-0 w-[3px] rounded-r-full" style={{ backgroundColor: brandFill(item.brand) }} />
      <p className="line-clamp-3 break-words text-callout font-semibold leading-snug text-label">{item.title}</p>
      <p className="mt-1.5 flex min-w-0 items-center gap-2 text-caption">
        <span className="min-w-0 truncate font-semibold" style={{ color: brandText(item.brand) }}>
          {BRAND_INFO[item.brand].name}
        </span>
        {item.updatedBy === 'claude' && (
          <span title="Zuletzt von Claude geändert" aria-label="von Claude" className="shrink-0 text-label2/45">
            <Icon name="claude" size={11} />
          </span>
        )}
        <span className={`num ml-auto shrink-0 ${late ? 'font-semibold text-danger' : 'text-label2/60'}`}>{relative(item.start)}</span>
      </p>
    </button>
  )
}
